import { createAction } from "@reduxjs/toolkit";

const vendorRouteActions = {
  redirect: createAction("vendor/routes/setRoute", (route: string) => ({
    payload: { route },
  })),
  clearNextRoute: createAction("vendor/routes/clearRoute"),
};

export default vendorRouteActions;
